<nf-grid-wrapper [hideSearch]="true" [hideClearAll]="true">
  <nf-grid-wrapper-header-left>
    <h2 class="title">External</h2>
    <ng-container *ngIf="!_cacheLoaded">
      <span
        id="icon-alert"
        class="mdi mdi-alert-circle text-warning ml-1"
        ngbTooltip="Filter results may be incomplete as data is still loading."
        placement="right"
      ></span>
      <ngb-alert id="banner-alert" class="mb-0 py-0 pl-2 pr-4 ml-1">
        <strong class="mr-1"
          >Filter results may be incomplete as data is still loading.</strong
        >
      </ngb-alert>
    </ng-container>
  </nf-grid-wrapper-header-left>
  <ng-grid-wrapper-header-right class="d-flex">
    <div id="status-quickfilter" class="d-flex mr-2">
      <nf-checkbox
        class="small"
        label="Unmatched"
        [formControl]="includeUnmatchedFormControl"
      >
      </nf-checkbox>
      <nf-checkbox
        class="small"
        label="Held"
        [formControl]="includeHeldFormControl"
      ></nf-checkbox>
      <nf-checkbox
        class="small"
        label="Ignored"
        [formControl]="includeIgnoredFormControl"
      >
      </nf-checkbox>
      <nf-checkbox
        class="small"
        label="Matched"
        [formControl]="includeMatchedFormControl"
      >
      </nf-checkbox>
    </div>
    <nf-form-control compact for="quickSearchAssetIds">
      <input
        type="text"
        class="form-control"
        [formControl]="quickSearchAssetIds"
        placeholder="Asset Ids (e.g. 1,2,3)"
      />
    </nf-form-control>
  </ng-grid-wrapper-header-right>
  <ng-grid-wrapper-header-right>
    <div ngbDropdown placement="bottom-right">
      <button
        ngbDropdownToggle
        nf-icon-button
        class="ext-actions-button"
        ngbTooltip="Ext Transactions Actions"
        placement="bottom-right"
        icon="dots-vertical"
        style="margin-left: 8px"
      >
        Ext Transactions Actions
      </button>
      <div
        ngbDropdownMenu
        aria-labelledby="dropdown"
        class="dropdown-menu dropdown-menu-right"
      >
        <button
          type="button"
          class="dropdown-item btn btn-link"
          (click)="exportExtTranToExcel()"
        >
          Export to Excel
        </button>
      </div>
    </div>
  </ng-grid-wrapper-header-right>
  <ng-grid-wrapper-header-right>
    <button
      nf-icon-button="secondary"
      ngbTooltip="Filters Modal"
      placement="bottom-right"
      icon="filter"
      (click)="launchFiltersModal()"
      data-cy="advancedFiltersBtn"
    >
      Open Filters Modal
    </button>
    <hs-applied-filter-counts
      [filterCount]="filterCount"
    ></hs-applied-filter-counts>
  </ng-grid-wrapper-header-right>
  <ng-grid-wrapper-header-right>
    <button
      id="clear-all-filters-button"
      nf-icon-button="secondary"
      (click)="resetAllFilters()"
      icon="filter-remove"
      ngbTooltip="Reset All Filters to Default"
      [disabled]="!resetAllFiltersEnabled"
      placement="bottom-right"
    >
      Clear All Filters
    </button>
  </ng-grid-wrapper-header-right>
  <nf-grid-wrapper-content *ngIf="gridOptions$ | async as gridOptions">
    <nf-table-layout
      tableTitle="External Transactions"
      [hideTitle]="true"
      [isSectionTitle]="true"
      [gridOptions]="gridOptions"
      [modules]="gridModules"
      hideSearch
      hideClearAll
      [autoResizeGrid]="false"
    >
    </nf-table-layout>
  </nf-grid-wrapper-content>
</nf-grid-wrapper>
